var _g, _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakingBoxes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 54,
    height: 51,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1491 37.7087C39.2019 36.7783 40.0409 36.0377 42.8535 34.9811C44.2008 34.474 43.3815 33.4047 43.4183 32.5492C43.4348 32.1577 44.9744 32.2357 44.8627 30.7254C44.784 29.6617 42.441 28.1463 41.8026 27.4996C41.4339 27.1264 42.554 26.1053 41.7651 25.2073C40.6882 23.98 40.5181 21.8445 39.8664 20.6501C39.8664 20.6501 40.3633 19.8911 39.9825 19.4596C36.6977 15.7414 24.44 16.0828 21.3076 21.5551C17.7911 27.6982 17.7442 36.1888 25.0556 40.7631C28.3074 42.7971 24.1424 50 24.1424 50H37.0372C37.0372 48.7701 35.5992 44.3582 38.1161 44.5562C40.303 44.7282 42.9811 44.6337 42.7437 42.1637C42.672 41.4187 42.5876 40.7479 43.108 40.1304C43.6284 39.5136 44.3817 38.4131 42.1491 37.7087Z",
    fill: "#3EC6CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1007 36.5493L57.0766 38.118V34.9811L45.1007 36.5493Z",
    fill: "#3EC6CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8301 46.8783L56.1145 44.1615L45.1007 38.2164L54.8301 46.8783Z",
    fill: "#3EC6CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1145 28.9091L54.8301 26.1916L45.1007 34.8548L56.1145 28.9091Z",
    fill: "#3EC6CA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_9",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_9",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakingBoxes);
export default __webpack_public_path__ + "static/media/speaking-boxes.54bcca24c6286a7ac69fc21edefc72e0.svg";
export { ForwardRef as ReactComponent };